(function () {
  var container = document.getElementById('main-content');
  var headerWrap = document.getElementById('headerWrap');
  if (!container || !headerWrap) return;

  var navItems = document.querySelectorAll('[data-slide]');
  var continueButtons = document.querySelectorAll('[data-goto]');
  var sections = container.querySelectorAll('.lc-section');

  function getNavSlide(index) {
    if (index <= 1) return '1';
    if (index <= 3) return '2';
    if (index === 4) return '4';
    return '5';
  }

  function updateActiveNav(slideId) {
    navItems.forEach(function (item) {
      var itemSlide = item.getAttribute('data-slide');
      if (itemSlide === slideId) {
        item.classList.add('nav-selected');
        if (item.getAttribute('role') !== 'button') {
          item.setAttribute('aria-current', 'true');
        }
      } else {
        item.classList.remove('nav-selected');
        item.removeAttribute('aria-current');
      }
    });
  }

  function handleScroll() {
    var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    var viewHeight = window.innerHeight;
    var currentIndex = Math.round(scrollTop / viewHeight);

    if (scrollTop > 10) {
      headerWrap.classList.add('scrolled');
    } else {
      headerWrap.classList.remove('scrolled');
    }

    updateActiveNav(getNavSlide(currentIndex));
  }

  function goToSlide(index) {
    var target = sections[index];
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  }

  // Scroll listener on window (natural document scrolling)
  window.addEventListener('scroll', handleScroll, { passive: true });
  handleScroll();

  // Nav click handlers
  navItems.forEach(function (item) {
    var slideIndex = parseInt(item.getAttribute('data-slide'), 10);

    item.addEventListener('click', function (e) {
      e.preventDefault();
      goToSlide(slideIndex);
    });

    if (item.getAttribute('role') === 'button') {
      item.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          goToSlide(slideIndex);
        }
      });
    }
  });

  // Continue button handlers
  continueButtons.forEach(function (btn) {
    var targetIndex = parseInt(btn.getAttribute('data-goto'), 10);
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      goToSlide(targetIndex);
    });
  });

  // ========================================
  // Cart Drawer
  // ========================================

  var cartDrawer = document.getElementById('cartDrawer');
  var cartOverlay = document.getElementById('cartOverlay');
  var cartToggle = document.getElementById('cartToggle');
  var cartClose = document.getElementById('cartClose');
  var cartContinue = document.getElementById('cartContinue');
  var cartBody = document.getElementById('cartBody');
  var cartFooter = document.getElementById('cartFooter');
  var cartSubtotal = document.getElementById('cartSubtotal');
  var cartCount = document.getElementById('cartCount');
  var addToCartForm = document.getElementById('addToCartForm');
  var addToCartBtn = document.getElementById('addToCartBtn');

  function openCart() {
    cartDrawer.classList.add('open');
    cartOverlay.classList.add('open');
    document.body.classList.add('cart-open');
  }

  function closeCart() {
    cartDrawer.classList.remove('open');
    cartOverlay.classList.remove('open');
    document.body.classList.remove('cart-open');
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function updateCartCount(count) {
    if (count > 0) {
      cartCount.textContent = count;
      cartCount.style.display = 'flex';
    } else {
      cartCount.style.display = 'none';
    }
  }

  function renderCart(cart) {
    updateCartCount(cart.item_count);

    if (cart.items.length === 0) {
      cartBody.innerHTML = '<p class="lc-cart-empty">Your cart is empty.</p>';
      cartFooter.style.display = 'none';
      return;
    }

    var html = '';
    cart.items.forEach(function (item) {
      var imgSrc = item.image ? item.image.replace(/(\.[^.]+)$/, '_160x160$1') : '';
      html += '<div class="lc-cart-item" data-key="' + item.key + '">';
      if (imgSrc) {
        html += '<img class="lc-cart-item-img" src="' + imgSrc + '" alt="' + item.title + '">';
      }
      html += '<div class="lc-cart-item-details">';
      html += '<div class="lc-cart-item-title">' + item.product_title + '</div>';
      html += '<div class="lc-cart-item-price">' + formatMoney(item.final_line_price) + '</div>';
      html += '<div class="lc-cart-qty">';
      html += '<button class="lc-cart-qty-minus" data-key="' + item.key + '" aria-label="Decrease quantity">&minus;</button>';
      html += '<span class="lc-cart-qty-count">' + item.quantity + '</span>';
      html += '<button class="lc-cart-qty-plus" data-key="' + item.key + '" aria-label="Increase quantity">+</button>';
      html += '</div>';
      html += '<button class="lc-cart-item-remove" data-key="' + item.key + '">Remove</button>';
      html += '</div>';
      html += '</div>';
    });

    cartBody.innerHTML = html;
    cartSubtotal.textContent = formatMoney(cart.total_price);
    cartFooter.style.display = 'flex';

    // Bind quantity and remove buttons
    cartBody.querySelectorAll('.lc-cart-qty-minus').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-key');
        var countEl = btn.parentNode.querySelector('.lc-cart-qty-count');
        var qty = parseInt(countEl.textContent, 10) - 1;
        changeItem(key, Math.max(0, qty));
      });
    });

    cartBody.querySelectorAll('.lc-cart-qty-plus').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-key');
        var countEl = btn.parentNode.querySelector('.lc-cart-qty-count');
        var qty = parseInt(countEl.textContent, 10) + 1;
        changeItem(key, qty);
      });
    });

    cartBody.querySelectorAll('.lc-cart-item-remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-key');
        changeItem(key, 0);
      });
    });
  }

  function fetchCart() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(renderCart);
  }

  function changeItem(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(renderCart);
  }

  // Open/close handlers
  if (cartToggle) cartToggle.addEventListener('click', function () { fetchCart(); openCart(); });
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);
  if (cartContinue) cartContinue.addEventListener('click', closeCart);

  // Escape key closes cart
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && cartDrawer.classList.contains('open')) {
      closeCart();
    }
  });

  // AJAX add-to-cart
  if (addToCartForm) {
    addToCartForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(addToCartForm);
      var data = {
        id: formData.get('id'),
        quantity: parseInt(formData.get('quantity'), 10)
      };

      addToCartBtn.disabled = true;
      addToCartBtn.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          addToCartBtn.disabled = false;
          addToCartBtn.textContent = 'Purchase';
          fetchCart();
          openCart();
        })
        .catch(function () {
          addToCartBtn.disabled = false;
          addToCartBtn.textContent = 'Purchase';
        });
    });
  }

  // Load initial cart count on page load
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) { updateCartCount(cart.item_count); });
})();
